import { makeAutoObservable, makeObservable, observable } from 'mobx';
import { CourseInfo } from '../api/types/programs/course/course-info';
import { CourseDetailsType } from '../api/types/programs/course/course-details.type';
import { CourseMetadataType } from '../api/types/programs/course/course-metadata.type';
import { LecturerType } from '../api/types/programs/course/lecturers/course-lecturer';
import AppApi from '../api/app-api';

class GlobalCourseStore {
  private _version = 0;

  private _courses: Map<number, CourseInfo> = new Map<number, CourseInfo>();
  private _currentId: number | undefined;
  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
  }

  fetchCourseDetails = async (programId: number, courseId: number) => {
    const res = await AppApi.getCourseDetails(programId, courseId);
    globalCourseStore.addCourseMetadata(res.data.body.metadata);

    globalCourseStore.addCourseDetails(courseId, res.data.body.details);
    globalCourseStore.currentId = courseId;
    this._version++;
  };

  getCurrentCourse = () => {
    if (this._currentId && this._courses.has(this._currentId)) {
      return this._courses.get(this._currentId);
    } else {
      return null;
    }
  };

  addCourseMetadata = (metadata: CourseMetadataType) => {
    this._courses.set(metadata.id, { metadata: metadata });
  };

  addCourseMetadataList = (metadataList: CourseMetadataType[]) => {
    metadataList.forEach(this.addCourseMetadata);
  };

  addCourseDetails = (courseId: number, details: CourseDetailsType) => {
    if (this._courses.has(courseId)) {
      this._courses.get(courseId)!.details = details;
    } else {
      throw new Error("Can't detetct course");
    }
  };

  addLecturers = (lecturers: LecturerType[]) => {
    const course = this.getCurrentCourse();
    if (course?.details) {
      // This checks both course and details
      const currentLecturers = course.details.lecturer ?? [];
      course.details.lecturer = [...currentLecturers, ...lecturers];
    }
  };

  removeLecturer = (lecturerId: number) => {
    const course = this.getCurrentCourse();
    if (course?.details) {
      const currentLecturers = course.details.lecturer ?? [];
      course.details.lecturer = currentLecturers.filter(
        (lecturer) => lecturer.id !== lecturerId,
      );
    }
  };

  updateCourseDetails = (courseId: number, metadata, details) => {
    globalCourseStore.addCourseMetadata(metadata);

    globalCourseStore.addCourseDetails(courseId, details);
    globalCourseStore.currentId = courseId;

    this._version++;
  };
  get version() {
    return this._version;
  }
  get courses(): Map<number, CourseInfo> {
    return this._courses;
  }

  set courses(value: Map<number, CourseInfo>) {
    this._courses = value;
  }

  get currentId(): number | undefined {
    return this._currentId;
  }

  set currentId(value: number | undefined) {
    this._currentId = value;
  }
}
const globalCourseStore = new GlobalCourseStore();
export default globalCourseStore;
